import { NearestBoreholeObject } from '../dataSources/geo/NearestBoreHoles'
import { AddressReverseResult } from '../dataSources/dataforsyningen/AddressReverse'
import {
  FETCHING_BOREHOLE_FAILURE, FETCHING_BOREHOLE_STARTED, FETCHING_BOREHOLE_SUCCESS,
  FETCHING_ADDRESS_FAILURE, FETCHING_ADDRESS_STARTED, FETCHING_ADDRESS_SUCCESS,
  FETCHING_IMAGE_SUCCESS, FETCHING_IMAGE_STARTED, FETCHING_IMAGE_FAILURE,
  FETCHING_LEGEND_SUCCESS, FETCHING_LEGEND_STARTED, FETCHING_LEGEND_FAILURE, CLEAR_STATE
} from '../actions/BoreholeInfoActions'
import { CallResult, MessageAction, DataAction, BaseAction } from '../CustomTypes'
import { BoreholeLegendObject } from '../dataSources/geo/BoreholeLegend'

export interface BoreholeInfoState {
  fetchBoreholeStatus: CallResult
  fetchBoreholeError: string
  selectedBorehole?: NearestBoreholeObject

  fetchAddressStatus: CallResult
  fetchAddressError: string
  addressInfo?: AddressReverseResult

  fetchImageStatus: CallResult
  fetchImageError: string
  boreholeSvg: string

  fetchLegendStatus: CallResult
  fetchLegendError: string
  legend?: BoreholeLegendObject
}

export const boreholeInfoStateInitial: BoreholeInfoState = {
  fetchBoreholeStatus: CallResult.Initial,
  fetchBoreholeError: '',
  selectedBorehole: undefined,
  fetchAddressStatus: CallResult.Initial,
  fetchAddressError: '',
  addressInfo: undefined,
  fetchImageStatus: CallResult.Initial,
  fetchImageError: '',
  boreholeSvg: '',
  fetchLegendStatus: CallResult.Initial,
  fetchLegendError: '',
  legend: undefined
}

export function boreholeInfoReducer (
  state: BoreholeInfoState = boreholeInfoStateInitial, // eslint-disable-line @typescript-eslint/default-param-last
  action: BaseAction): BoreholeInfoState {
  switch (action.type) {
    case FETCHING_BOREHOLE_STARTED: {
      return {
        ...state,
        fetchBoreholeStatus: CallResult.Running
      }
    }
    case FETCHING_BOREHOLE_FAILURE: {
      const a = action as MessageAction
      return {
        ...state,
        fetchBoreholeStatus: CallResult.Failed,
        fetchBoreholeError: a.message
      }
    }
    case FETCHING_BOREHOLE_SUCCESS: {
      const a = action as DataAction<NearestBoreholeObject | null>
      return {
        ...state,
        fetchBoreholeStatus: CallResult.Succeeded,
        selectedBorehole: a.data !== null ? a.data : undefined
      }
    }
    case FETCHING_ADDRESS_STARTED: {
      return {
        ...state,
        fetchAddressStatus: CallResult.Running
      }
    }
    case FETCHING_ADDRESS_FAILURE: {
      const a = action as MessageAction
      return {
        ...state,
        fetchAddressStatus: CallResult.Failed,
        fetchAddressError: a.message
      }
    }
    case FETCHING_ADDRESS_SUCCESS: {
      const a = action as DataAction<AddressReverseResult>
      return {
        ...state,
        fetchAddressStatus: CallResult.Succeeded,
        addressInfo: a.data
      }
    }
    case FETCHING_IMAGE_STARTED: {
      return {
        ...state,
        fetchImageStatus: CallResult.Running
      }
    }
    case FETCHING_IMAGE_FAILURE: {
      const a = action as MessageAction
      return {
        ...state,
        fetchImageStatus: CallResult.Failed,
        fetchImageError: a.message
      }
    }
    case FETCHING_IMAGE_SUCCESS: {
      const a = action as DataAction<string>
      return {
        ...state,
        fetchImageStatus: CallResult.Succeeded,
        boreholeSvg: a.data
      }
    }
    case FETCHING_LEGEND_STARTED: {
      return {
        ...state,
        fetchLegendStatus: CallResult.Running
      }
    }
    case FETCHING_LEGEND_FAILURE: {
      const a = action as MessageAction
      return {
        ...state,
        fetchLegendStatus: CallResult.Failed,
        fetchLegendError: a.message
      }
    }
    case FETCHING_LEGEND_SUCCESS: {
      const a = action as DataAction<BoreholeLegendObject>
      return {
        ...state,
        fetchLegendStatus: CallResult.Succeeded,
        legend: a.data
      }
    }
    case CLEAR_STATE: {
      return {
        ...state,
        ...boreholeInfoStateInitial
      }
    }
    default:
      return state
  }
}
